import React from "react";
import Form_component from "./form_component/Form_component";
import Reviews from "./Reviews/Reviews";
import How_product_care_work from "./how_product_care_work/How_product_care_work";
import Your_Idea from "../../common_components/your_Idea/Your_Idea";

function Personal_care() {
  return (
    <>
      {" "}
      <Your_Idea  btnText={"Customize Bespoke Gifts"}/>
      <How_product_care_work />
      <Form_component />
      <Reviews />
    </>
  );
}

export default Personal_care;
